import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const JourneyCreatedFromItinerary = ({ changes: { source }, ...props }) => {
  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        {source}
      </Text>
    </Spacer>
  );
};

export default JourneyCreatedFromItinerary;
